import type { ReactNode } from 'react'
import { Button } from '@/components/ui/button'
import { useTradeAccountsGate } from '@/hooks/useTradeAccountsEnabled'

// Route-level gate for Trade accounts (F-TRD-N1): nothing mounts unless this
// tenant has FEATURE_TRADE_ACCOUNTS=1.
export function TradeGate({ children }: { children: ReactNode }) {
  const gate = useTradeAccountsGate()
  if (gate.enabled) return <>{children}</>
  if (gate.isLoading) return <div className="p-6 text-sm text-muted-foreground">Loading…</div>
  if (gate.isError)
    return (
      <div className="flex flex-col items-center gap-3 p-8 text-center">
        <p className="text-sm text-muted-foreground">Couldn’t load settings. Check your connection and try again.</p>
        <Button variant="outline" onClick={gate.retry}>
          Retry
        </Button>
      </div>
    )
  return <div className="p-8 text-center text-sm text-muted-foreground">Trade isn’t switched on for this restaurant.</div>
}
